import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

// Function to save form data for Section 11
export const writeDataS11 = async (formData) => {
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Declaration"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 11 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 11 data to Firestore: ", error);
  }
};
